import React from 'react';
import QuotesList from '../components/quotes/quotes-list';

// page style
import '../../styles/pages/quotes-page.scss';
import { useAnalyticsContext } from '@llt-frontend/react-analytics-context';

export function QuotesPage() {
  const { trackEvent } = useAnalyticsContext();

  // side-effects

  React.useEffect(function _setTitle() {
    document.title = 'Quotes | Varsity Tutors';
  });

  React.useEffect(
    function _trackVisit() {
      trackEvent({ category: 'visits', action: 'quotes_page' });
    },
    [trackEvent]
  );

  React.useEffect(function _trackSegmentPageView() {
    window['analytics']?.page?.({
      metadata: {
        is_packages_page: true,
      },
    });
  }, []);

  // render

  return (
    <div className="quotes-page">
      <QuotesList />
    </div>
  );
}

export default QuotesPage;
